import * as api from '../../api/api-dashboard-intercia';
import {
    GET_RESUMEN_INTERCIA,
    SET_FILTROS_INTERCIA
} from '../types';


// `meta.query` guarda con qué filtros se cargó el resumen: la exportación de casos (RG-602) debe usar
// esos mismos, no los que el usuario esté editando en el panel sin haber pulsado Buscar.
export const obtenerResumenIntercia = (query) => ({
    type: GET_RESUMEN_INTERCIA,
    payload: api.getResumenDashboard(query),
    meta: { query }
});
export const setFiltrosIntercia = (filtros) => ({
    type: SET_FILTROS_INTERCIA,
    payload: filtros
});
